import {
  Datagrid,
  DateField,
  EditButton,
  FunctionField,
  List,
  TextField,
  SearchInput,
  TextInput,
} from 'react-admin';
import { CustomActions, IndexField } from '../../components';
import { Box, Card, CardContent, Typography } from '@mui/material';

const postFilters = [
  <SearchInput placeholder="Search by site name" source="site.name" alwaysOn />,
  <TextInput label="Name" source="name" />,
];

const ListRoute = () => (
  <Card variant='elevation'>
    <CardContent>
      <Box>
        <Typography variant="h4">Manage Routes</Typography>
        <List
          filters={postFilters}
          actions={<CustomActions addBtnLabel='Add Route' type="list" />}
        >
          <Datagrid rowClick="edit" size='medium' bulkActionButtons={false} sx={{ borderTop: '1px solid grey', maxHeight: '70vh', overflow: 'auto' }}>
            <FunctionField
              label='NO'
              render={(record) => <IndexField record={record} />}
            />
            <TextField label='NAME' source="name" sortable={false} />
            <TextField label='SITE' source="site.name" sortable={false} />
            <TextField label='ROUTE TYPE' source="route_type.name" sortable={false} />
            <FunctionField
              label='CHECKPOINTS'
              render={(record) => record.route_checkpoints?.items?.length}
            />
            <DateField label='MODIFIED TIME' locales="en-SG" source='updatedAt' showTime sortable={false} />
            <FunctionField
              label='ACTION'
              render={(record) => <EditButton label='' record={record} sx={{ color: 'white' }}/>}
            />
          </Datagrid>
        </List>
      </Box>
    </CardContent>
  </Card>
);

export default ListRoute;
export { ListRoute };